var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.boxWrap},[(_vm.noData)?_c('no-data',{attrs:{"isIcon":"","font":"300px"}}):_c('div',{class:_vm.$style.box,style:({ width: _vm.width, height: _vm.height }),attrs:{"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }